<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="장소별 점검항목 목록"
          :columns="grid.columns"
          :data="resultItems"
          :merge="grid.merge"
          :usePaging="false"
          selection="multiple"
          rowKey="saiPatrolResultItemId"
          :editable="editable"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable && pick.placeId" 
                label="삭제" 
                icon="remove" 
                @btnClicked="deleteItem" />
              <c-btn 
                v-if="editable && pick.placeId" 
                label="추가" 
                :showLoading="false" 
                icon="add" 
                @btnClicked="addItem" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-place-item-result',
  props: {
    resultItems: {
      type: Array,
      default: () => []
    },
    pick: {
      type: Object,
      default: () => ({
        plantCd: '',
        placeId: '',
      }) 
    },
  },
  data() {
    return {
      editable: true,
      popupOptions: {
        isFull: false,
        width: '50%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'saiEquipClassName' },
          { index: 1, colName: 'groupItemClass' },
        ],
        columns: [
          {
            name: 'saiEquipClassName',
            field: 'saiEquipClassName',
            label: '설비분류',
            align: 'center',
            sortable: true,
            style: 'width:15%',
          },
          {
            name: 'saiItemClassName',
            field: 'saiItemClassName',
            label: '항목분류',
            align: 'center',
            sortable: true,
            style: 'width:15%',
          },
          {
            name: 'patrolItemName',
            field: 'patrolItemName',
            label: '점검항목',
            align: 'left',
            sortable: true,
            style: 'width:70%',
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.insertUrl = transactionConfig.sai.patrol.itemPlace.insert.url;
      this.deleteUrl = transactionConfig.sai.patrol.itemPlace.delete.url;
    },
    
    addItem() {
      if (!this.pick.placeId) return;
      this.popupOptions.title = '순회점검항목';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.pick.plantCd
      };
      this.popupOptions.target = () => import(`${'./patrolItemPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let insertData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.resultItems, { saiPatrolResultItemId: item.saiPatrolResultItemId }) === -1) {
            // let idx = this.$_.findIndex(this.resultItems, { saiEquipClassName: item.saiEquipClassName, saiItemClassName: item.saiItemClassName })
            // idx = idx === -1 ? this.$_.findIndex(this.resultItems, { saiEquipClassName: item.saiEquipClassName }) : 0
            // idx = idx === -1 ? 0 : idx;
            insertData.push({
              placeId: this.pick.placeId,
              saiPatrolResultItemId: item.saiPatrolResultItemId,
              saiEquipClassName: item.saiEquipClassName,
              saiItemClassName: item.saiItemClassName,
              patrolItemName: item.patrolItemName,
            })
          }
        })
        
        this.$http.url = this.insertUrl;
        this.$http.type = 'POST';
        this.$http.param = insertData
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.$emit('getList');
          this.$emit('rowClick', this.$_.cloneDeep(this.pick));
        },);
      }
    },
    deleteItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            // this.$_.forEach(selectData, item => {
            //   this.resultItems = this.$_.reject(this.resultItems, item);
            // })
            this.$refs['table'].$refs['compo-table'].clearSelection();
            this.$emit('getList');
            /**
             * 입력하는 항목이 없음으로 삭제 처리 후에 조회처리
             */
            this.$emit('rowClick', this.$_.cloneDeep(this.pick));
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
  }
};
</script>
